export default "__VITE_ASSET__DGJ2WEjh__"